export class PreguntaData {
  id: string;
  pregunta: string;
  respuesta: string;
  video?: string | undefined;

  constructor(
    id: string,
    pregunta: string,
    respuesta: string,
    video?: string | undefined
  ) {
    this.id = id;
    this.pregunta = pregunta;
    this.respuesta = respuesta;
    this.video = video;
  }

  tienePregunta(): boolean {
    return !!this.pregunta && this.pregunta.trim().length > 0;
  }

  tieneRespuesta(): boolean {
    return !!this.respuesta && this.respuesta.trim().length > 0;
  }

  tieneVideo(): boolean {
    return !!this.video && this.video.trim().length > 0;
  }

  static fromJson(json: any): PreguntaData {
    return new PreguntaData(json.id, json.pregunta, json.respuesta, json.video);
  }
}
